export enum MatchingInvoiceActionType {
Skip,
Overwrite,
Duplicate,
}
